// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Selecionar',
    titleLinkTooltip: 'Ir para a página',
    collapseCardTooltip: 'Contrair o cartão',
    expandCardTooltip: 'Expandir o cartão'
  },
  CardList: {
    loadMore: 'Carregar mais',
    notFound: 'Sem resultados.',
    toolbarSelect: 'Selecionar',
    viewCards: 'Cartões',
    viewTiles: 'Mosaico',
    viewList: 'Lista',
    toolbarView: 'Visualizar'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Sair',
    cancel: 'Retroceder',
    content: 'Tem a certeza de que fechar esta janela? Quaisquer alterações que tenha efetuado não serão guardadas.'
  },
  Cuttable: {
    showMore: 'Mostrar mais',
    showLess: 'Mostrar menos'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Cancelar'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Cancelar'
  },
  Dropdown: {
    close: 'Fechar'
  },
  Form: {
    submitButton: 'Guardar',
    applyButton: 'Aplicar',
    cancelButton: 'Cancelar'
  },
  FormField: {
    clear: 'Limpar',
    remove: 'Remover',
    addMore: 'Adicionar mais um',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Para melhorar a sua palavra-passe:',
    passwordTooShort: 'Torne a sua palavra-passe mais longa.',
    lettersLowerCase: 'Utilize, pelo menos, um caractere minúsculo.',
    lettersUpperCase: 'Utilize, pelo menos, um caractere maiúsculo.',
    numbers1: 'Utilize, pelo menos, um número.',
    numbers3: 'Utilize, pelo menos, três números.',
    specialChar1: 'Utilize, pelo menos, um caractere especial (por exemplo: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Utilize, pelo menos, dois caracteres especiais (por exemplo: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Utilize caracteres maiúsculos e minúsculos.',
    comboLettersAndNumbers: 'Utilize números e caracteres.',
    comboLettersNumbersSpecial: 'Utilize números, caracteres e caracteres especiais.',
    yourPasswordIsStrong: 'Pode torná-la ainda mais forte aumentando o seu comprimento.',
    passwordStrength: 'A força da sua palavra-passe é: %%strength%%.',
    strengthVeryStrong: 'MUITO FORTE',
    strengthStrong: 'FORTE',
    strengthVeryWeak: 'MUITO FRACA',
    strengthWeak: 'FRACA',
    strengthMedium: 'MÉDIA',
    hidePassword: 'Ocultar a palavra-passe',
    showPassword: 'Mostrar a palavra-passe',
    generateButton: 'Gerar',
    copyButtonHint: 'Copiar a palavra-passe',
    copySuccessToast: 'A palavra-passe foi copiada',
    generateButtonHint: 'Gerar uma palavra-passe mais forte'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Rejeitar as alterações',
    editButtonHint: 'Editar o valor',
    okButtonHint: 'Guardar as alterações'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Escolha o ficheiro...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: 'Total de %%totalRows%% artigos',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '%%selectedRows%% de %%totalRows%% artigos selecionados',
    all: 'Todos',
    allItemsOnPageSelected: 'Todos os artigos da página foram selecionados',
    allItemsSelected: 'Todos os artigos selecionados',
    selectAllItems: 'Selecionar todos os artigos',
    selectAllItemsOnPage: 'Selecionar todos os artigos da página',
    deselectAll: 'Anular seleção',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Não foi possível encontrar artigos correspondentes ao filtro',
    emptyTitle: 'Parece que não há nada aqui',
    filteredDescription: 'Refine a sua consulta ou remova alguns critérios do filtro e tente novamente.'
  },
  ListOperation: {
    cancelButton: 'Cancelar'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'de %%total%%',
    itemsPerPage: 'Artigos por página',
    all: 'Tudo',
    total: 'Página %%current%% de %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Fechar',
    cancelButton: 'Cancelar'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Sem opções',
    placeholder: 'Selecione...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% de %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Fechar o grupo'
  },
  Toast: {
    closeButton: 'Close'
  }
};